import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isBrowser } from 'react-device-detect';
import CustomButton from '../../../../components/CustomButton';
import MediumModal from '../../../../components/modals/MediumModal';
import { closeLabOrderFinishModal } from '../../../../redux/actions/modals';
import { makeLabOrderDone } from '../../../../redux/actions/orders';
const FinishLabOrderModal = () => {
    const dispatch = useDispatch();
    const {lab_order_finish_open , lab_order_finish_order} = useSelector(state => state.modals);
    const {make_lab_order_done_waiting} = useSelector(state => state.orders);
    const submit = () => {
        dispatch(makeLabOrderDone(lab_order_finish_order.id));
    };
    let header_title = "آیا از ارسال تمامی نتایج اطمینان دارید؟";
    if(lab_order_finish_order.order_type === 'home_care'){
        header_title = "آیا از اتمام انجام خدمات اطمینان دارید؟"
    }
    return (
        <MediumModal
            header={header_title}
            show={lab_order_finish_open}
            className={isBrowser ? "" : "homecare-done-modal"}
            closeFunction={closeLabOrderFinishModal}
        >
            <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <CustomButton
                        action={submit}
                        loading={make_lab_order_done_waiting}
                        content={"تایید و ارسال"}
                        type={'success'}
                        block={true}
                        textWhite={true}
                    />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <button
                        className="btn btn-small btn-outline-black full-width"
                        onClick={() => {
                        dispatch(closeLabOrderFinishModal());
                        }}
                        >
                        خیر! منصرف شدم
                    </button>
                </div>
                
            </div>
        </MediumModal>
    )
};

export default FinishLabOrderModal;